const organization = {
    require_membership: 'يجب أن يكون المستخدم عضوًا في المنظمة للمتابعة.',
    role_names_not_found: 'تم اكتشاف أسماء أدوار غير صالحة: {{names,list(type:conjunction)}}. يُرجى إنشاء هذه الأدوار أولاً قبل المتابعة.',
};
export default Object.freeze(organization);
